import { Button, Paper } from "@material-ui/core";
import styled, { css } from 'styled-components';

export const StyledPaper = styled(Paper)`
  display: flex;
  flex: 1;

  height: calc(100% - 660px);
  
  padding: 16px;
`;

export const SideTitle = styled.p`
  color: #031795;
  
  font-size: 1.25rem;
  font-family: AASmartSans, Arial;
  font-weight: 700;
  
  line-height: 1.57;
  
  margin-block-start: 0px;
  margin-block-end: 0px;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  margin-bottom: 16px;
`;

export const FileHeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ViewOptionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  
  button + button {
    margin-left: 6px;
  }
`;

export const ViewOptionButton = styled.button`
  ${({ selected }) => css`
    padding: 8px;
    height: 42px;
    min-width: 42px;
    width: 42px;
    border-radius: 50%;
    
    background-color: transparent;
    
    background-color: ${selected ? '#002277' : 'transparent'};
    border: ${selected ? '0px solid #002277' : '1px solid #000'};
    color: ${selected ? '#fff' : '#000'};
    cursor: ${selected ? 'auto' : 'pointer'};
  `};
`;

export const FolderTreeSide = styled.div`
  display: flex;
  flex-direction: column;
  
  border-right: 1px solid #666666;
  
  min-width: 30%;
  max-width: 400px;
  
  padding-right: 16px;;
  `;

export const FilesSide = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  margin-left: 16px;

  overflow: auto;
`;

export const FilesContainer = styled.div`
  ${({ displayType }) => css`
    display: flex;
    flex-direction: ${displayType === 'list' ? 'column' : 'row'}
    gap: 16px;
    flex-wrap: wrap;
    margin-top: 6px;
  `}
`;

export const FilterButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 50%;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  
  button + button {
    margin-left: 16px;
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;

export const FieldContainer = styled.div`
  min-width: 200px;
  
  button {
    margin-left: 16px;
    height: 100%;
  }
    
  & +  div {
    margin-left: 16px;
  }
`;

export const ActionButton = styled.button`
  border: 0px solid ;
  border-radius: 50%;

  height: 42px;
  min-width: 42px;
  width: 42px;

  background-color: #E5E5E5;
  padding: 6px;
  
  cursor: pointer;
  
  :hover {
    background: #031795;
    color: #fff;
  }

  :disabled{

    :hover {
      background-color: #E5E5E5;
      color: #a5a5a5;
    }    
  }
`;

export const UploadButton = styled(Button)`
  border: 0px solid ;
  border-radius: 50%;

  margin-left: 16px;
  margin-right: 16px;

  height: 42px;
  width: 42px;
  min-width: 42px !important;

  background-color: #E5E5E5;
  padding: 6px;
  
  cursor: pointer;
  
  :hover {
    background: #031795;
    color: #fff;
  }

  :disabled{

    :hover {
      background-color: #E5E5E5;
      color: #a5a5a5;
    }    
  }
`;
